import { render, staticRenderFns } from "./CostItemContainer.vue?vue&type=template&id=0b94edb2&scoped=true&"
import script from "./CostItemContainer.vue?vue&type=script&lang=js&"
export * from "./CostItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./CostItemContainer.vue?vue&type=style&index=0&id=0b94edb2&prod&scoped=true&lang=css&"
import style1 from "./CostItemContainer.vue?vue&type=style&index=1&id=0b94edb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94edb2",
  null
  
)

export default component.exports